import { PublicClientApplication } from "@azure/msal-browser";

export const MSAL_CONFIG = {
  auth: {
    clientId: "bc73b0a1-f3d7-4d47-982f-ecca14984c65",
    authority: "https://login.microsoftonline.com/common",
    // Must be registered as an SPA redirect URI on the app registration, otherwise Entra
    // rejects the PKCE code redemption with AADSTS9002326.
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

let instancePromise = null;

// msal-browser v2 requires initialize() to complete before any other API call, and
// AuthService is constructed in several places (AuthComponent plus two auth actions),
// so the instance and its initialization are shared.
export const getMsalInstance = () => {
  if (!instancePromise) {
    const instance = new PublicClientApplication(MSAL_CONFIG);
    instancePromise = instance.initialize().then(() => instance);
  }

  return instancePromise;
};

export const getSignedInAccount = async () => {
  const instance = await getMsalInstance();
  const activeAccount = instance.getActiveAccount();

  if (activeAccount) {
    return activeAccount;
  }

  const allAccounts = instance.getAllAccounts();

  return allAccounts && allAccounts.length > 0 ? allAccounts[0] : null;
};
